@if (!isLoading) {
  <div class="pr-3 pl-3">
    <p-auto-complete (completeMethod)="search($event)"
                     (ngModelChange)="setUnit($event)"
                     [dropdown]="true"
                     [ngModel]="selectedUnit"
                     [suggestions]="filterList"
                     appendTo="body"
                     dropdownMode="blank"
                     optionLabel="name"></p-auto-complete>
  </div>
} @else {
  <p-skeleton height="54px" width="100%"></p-skeleton>
}
